'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('userService', ($q, apiEndpointFactory, sessionService, userStore, dispatcher,
  adobeAnalyticsService, $window, $state, $rootScope, $location, $cookies, otppConstants, localStorageEnabled ) => {

  const AUTH_LOGOUT_URL = $location.protocol() + '://' + $location.host() + '/auth/logout';

  let logoutEndpoint = apiEndpointFactory.new({
    endpointUrl: '/logout',
    allowedMethods: ['post'],
    authRequired: true
  });

  let iAccessLogoutEndpoint = apiEndpointFactory.new({
    endpointUrl: '/members/app/api/logout',
    allowedMethods: ['get'],
    isMemberApi: false
  });
  
  let accountEndpoint = apiEndpointFactory.new({
    endpointUrl: '/account',
    allowedMethods: ['post'],
    authRequired: true
  });

  function getInitalQueryString() {
    let queryString = window.location.href.split('?')[1];
    if (queryString !== undefined) {
      return '&' + queryString;
    }
    return '';
  }

  let service = {
    
    onLogin: (irn) => {
      dispatcher.dispatch('user:setRecentlyLoggedOut', false);

      let endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/member',
        authRequired: true,
        allowedMethods: ['get']
      });
      
      return $q.all([endpoint.get()]).then((promiseValues) => {
        let memberDetailsResponse = promiseValues[0].data;
        let userDetails = {
          firstName: memberDetailsResponse.firstName,
          memberStatus: memberDetailsResponse.pensionStatus.memberPensioner ? 'pensioner' : 'member',
          survivorPensioner: memberDetailsResponse.pensionStatus.survivorPensioner
        };

        dispatcher.dispatch('user:setUserDetails', userDetails);
        return memberDetailsResponse;
      }, (response) => {
        if(response.status===-1) {
          return $q.reject('LoginInterrupted');
        }
        return $q.reject(response);
      });
    },
    clearLoggedOut: () => {
      dispatcher.dispatch('user:setRecentlyLoggedOut', false);
    },

    setCurrentUserAccount: (userObj) => {
      dispatcher.dispatch('user:setUserAccount', userObj);
    },

    setCurrentUserDetails: (userDetailsObj) => {
      dispatcher.dispatch('user:setUserDetails', userDetailsObj);
    },
    logoutOfAuthZero: function(redirectToLanding = true) {
      if (redirectToLanding) {
        $window.location.href = AUTH_LOGOUT_URL;
      } else {
        fetch(AUTH_LOGOUT_URL, {mode: 'no-cors'});
      }
    },
    logoutIAccess: function(){
      return logoutEndpoint.post(null, sessionService.getToken()).then(function(){
        sessionService.resetSessionCheck();
        $cookies.remove(otppConstants.mbrAuthKey);
        $cookies.remove(otppConstants.bamKey);
      }, function(){
        sessionService.resetSessionCheck();
        iAccessLogoutEndpoint.get();
      });
    },
    logout: (redirectToLanding = true) => {
      $cookies.remove(otppConstants.authCallbackDestinationKey);

      let currentAccountHash = userStore.getAccountHash();
      if (currentAccountHash) {
        if (localStorageEnabled) {
          dispatcher.dispatch('psob:removeInStorage', currentAccountHash);
          dispatcher.dispatch('pensionModulesService:clearModules');
        }
      }

      adobeAnalyticsService.logout();
      sessionStorage.clear();

      service.logoutIAccess().finally(() => {
        sessionService.clearToken();
        dispatcher.dispatch('user:removeCurrentUser');
        dispatcher.dispatch('user:setRecentlyLoggedOut', true);
        dispatcher.dispatch('psob:removeAlert');
        service.logoutOfAuthZero(redirectToLanding);
      });
    },
    validatedUser: () => {
      let defer = $q.defer();
      return sessionService.validSession().then((data) => {
        $rootScope.redirectTo = undefined;
        if(data && data.account){
          if (!userStore.getIrn()) {
            service.setCurrentUserAccount({
              irn: data.account,
              accountHash: data.accountHash
            });
          }else{
            defer.resolve(userStore.getIrn());
          }
  
          service.onLogin(data.account).finally(function() {
            //DMWS-1109,remove logining status
            if(sessionStorage.getItem('loginLoading')==='true'){
              sessionStorage.removeItem('loginLoading');
            }
            defer.resolve(userStore.getIrn());
          });
        }else{
          defer.resolve();
        }
  
        return defer.promise;
      }).catch((response) => {
        let stateParams = {r: 'p.pension' + getInitalQueryString()};
        if ($rootScope.redirectTo) {
          stateParams = {r: $rootScope.redirectTo};
          $rootScope.redirectTo = undefined;
        }
  
        if (response.status >= 500 && response.status !== 503) {
          stateParams.err = '5xx';
        }
        if (response.status !== 503) {
          //DMWS-1157,cancel login process if manually switch to another route
          if (sessionStorage.getItem('loginLoading') === 'true') {
            $rootScope.$emit('cancelAllRequests');
          }
          $state.go('toMemberAuth', stateParams, {location: false, reload: false});
        }else{
          setTimeout(() => window.dispatchEvent(new Event('error-setting-up-session')), 1300);
        }
        defer.resolve();
        return defer.promise;
      });
    },

    getAccountInformation: () => {
      return accountEndpoint.post().then((response) => {
        return response.data;
      }, (response) => {
        return $q.reject(response);
      });
    }
  };

  return service;
});
